import { gql } from 'apollo-angular';

export const REGISTER_OMC_MUTATION = gql`
  mutation RegisterOmc($input: OmcRegReqInput) {
    registerOmc(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        brelaExpireDate
        brelaLicenseNumber
        brelaRegDate
        bucketName
        companyName
        createdAt
        createdBy
        email
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        financialYearId
        name
        registrationNumber
        registrationDate
        otherAttachmentName
        phoneNumber
        registrationStatus
        registrationType
        tin
        type
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const VERIFY_EWURA_LICENSE = gql`
  mutation VerifyEwuraLicense($input: EwuraLicenseReqInput) {
    verifyEwuraLicense(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        licenseType
        appRefNo
        ewuraRegDate: approvedDate
        cellPhone
        name: compName
        districtName
        email
        ewuraExpireDate: expDate
        licenseClass
        ewuraLicenseNumber: licenseNo
        regionName
        sector
        tin
        zoneName
      }
    }
  }
`;

export const VERIFY_BRELA_LICENSE = gql`
  mutation VerifyBrelaLicense($input: BrelaLicenseReqInput!) {
    verifyBrelaLicense(input: $input) {
      data {
        applicant
        blockNumber
        createdAt
        dateIssued
        districtName
        expireDate
        id
        isValid
        licenseNumber
        lineOfBusiness
        ownerName
        ownerRegion
        plotNumber
        road
        street
        tin
        unsurveyedArea
        wardName
      }
      extras
      fieldsErrors
      message
      status
      code
    }
  }
`;

export const VERIFY_IMPORT_LICENSE = gql`
  mutation VerifyImportationLicence {
    verifyImportationLicence {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        ewuraLicenseNumber
        incorpRegistrationCertificateIssuanceDate
        incorpRegistrationCertificateNumber
        licenseExpireDate
        licenseIssuedDate
        licenseStartDate
        licenseYear
        nameOfCompany
        omcNumber
        rawResponseJson
        tin
        uuid
        verified
        verifiedAt
      }
    }
  }
`;

export const GET_OMC_REGISTRATION_PROGRESS = gql`
  query OmcRegistrationProgress($omcUuid: UUID!) {
    omcRegistrationProgress(omcUuid: $omcUuid) {
      data {
        active
        allSectionsComplete
        applicationSubmitted
        applicationSubmittedAt
        brelaLicenseVerificationComplete
        brelaLicenseVerificationCompletedAt
        traLicenseVerificationComplete
        traLicenseVerificationCompletedAt
        createdAt
        createdBy
        documentCompletedAt
        licenseVerificationComplete
        licenseVerificationCompletedAt
        paymentComplete
        paymentCompletedAt
        requiredDocumentComplete
        termsAndConditionAccepted
        updatedAt
        updatedBy
        uuid
      }
      code
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const VIEW_OMC_DOCUMENTS = gql`
  query viewAttachmentByUuid($attachmentUuid: String!) {
    viewAttachmentByUuid(attachmentUuid: $attachmentUuid) {
      data
      extras
      fieldsErrors
      message
      status
      code
    }
  }
`;

export const GET_DOCUMENTS = gql`
  query GetAttachmentTypesByRegistrationType(
    $registrationType: RegistrationType!
    $companyType: CompanyType!
  ) {
    getAttachmentTypesByRegistrationType(
      companyType: $companyType
      registrationType: $registrationType
    ) {
      active
      attachmentType {
        active
        fileType
        fileSize
        id
        name
        uuid
      }
      forInternational
      forLocal
      isRequired
      registrationType
      uuid
    }
  }
`;

export const ADD_BRELA_LICENSE = gql`
  mutation AddBrelaLicense($input: BrelaLicenseReqInput) {
    addBrelaLicense(input: $input) {
      data {
        active
        address
        attachableDiscriminator
        brelaExpireDate
        brelaLicenseNumber
        brelaRegDate
        bucketName
        companyName
        createdAt
        createdBy
        email
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        financialYearId
        name
        registrationNumber
        registrationDate
        otherAttachmentName
        phoneNumber
        registrationStatus
        registrationType
        tin
        type
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
      code
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_OMC_APPLICATION = gql`
  mutation SubmitOmcApplication($input: OmcApplicationReqInput!) {
    submitOmcApplication(input: $input) {
      code
      data {
        active
        address
        createdAt
        createdBy
        email
        financialYearId
        name
        phoneNumber
        registrationDate
        registrationNumber
        registrationStatus
        tin
        updatedAt
        updatedBy
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_OMC_DOCUMENTS = gql`
  mutation AttachOmcDocument($input: OmcRegDocReqInput) {
    attachOmcDocument(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        email
        financialYearId
        name
        phoneNumber
        registrationDate
        registrationNumber
        registrationStatus
        tin
        uuid
        attachments {
          active
          id
          minioObjectName
          uuid
          attachable {
            id
          }
          attachmentType {
            active
            fileType
            id
            name
            uuid
          }
        }
      }
    }
  }
`;

export const OMC_REGISTRATION_SUMMARY = gql`
  query GetOmcRegistration($omcUuid: UUID!) {
    getOmcRegistration(omcUuid: $omcUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        brelaExpireDate
        brelaLicenseNumber
        brelaRegDate
        bucketName
        companyName
        traExpireDate
        traLicenseNumber
        traRegDate
        email
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        financialYearId
        name
        registrationNumber
        registrationDate
        otherAttachmentName
        phoneNumber
        registrationStatus
        registrationType
        tin
        type
        uuid
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
          itemList {
            collectionCenter
            collectionCenterId
            description
            gfsCode
            id
            isExempted
            quantity
            taxAmount
            totalAmount
            unitPrice
            billItemDetails {
              details
              id
              quantification
              taxAmount
              totalAmount
              unitPrice
            }
          }
          receipts {
            amount
            currency
            paymentDate
            receiptNo
            transactionId
            uuid
          }
        }
        attachments {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachmentType {
            active
            fileType
            id
            name
            uuid
          }
        }
        company {
          active
          addressDescription
          attachableDiscriminator
          brelaDataFetched
          brelaFetchedAt
          brelaRegistrationNumber
          bucketName
          companyType
          id
          name
          otherAttachmentName
          postalCode
          registrationCompletedAt
          registrationStatus
          registrationType
          taxPayerCenter
          taxPayerName
          taxPayerRegion
          taxPayerRegistrationDate
          taxpayerNumber
          tin
          tinOrTaxpayerNumber
          uuid
          website
          contactDetails {
                    active
                    contactType
                    content
                    id
                    uuid
                }
        }
      }
    }
  }
`;

export const DELETE_DOCUMENTS = gql`
  mutation DeleteAttachment($attachmentUuid: String!) {
    deleteAttachment(attachmentUuid: $attachmentUuid) {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GENERATE_CONTROL_NUMBER = gql`
  mutation GenerateControlNumber($billUuid: String!) {
    generateControlNumber(billUuid: $billUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        amountDue
        billDate
        billNumber
        billOpt
        billStatus
        billType
        billableId
        billableType
        billedBy
        billedEntityId
        billedEntityType
        canCancel
        canRequestControlNumber
        cancelAffected
        cancelReason
        changeBy
        changeReason
        cnDelivered
        collectionCenter
        controlNumber
        controlNumberExpiredDate
        currency
        description
        exchangeRate
        gfsCode
        id
        invoiceDate
        invoiceNumber
        invoicedBy
        modeOfSettlement
        paidAmount
        remarks
        sourceRef
        spCode
        subSpCode
        taxAmount
        totalAmount
        totalAmountAfterTax
        totalEqvAmount
        uuid
      }
    }
  }
`;

export const GET_BILL_BY_UUID = gql`
  query GetBillByUuid($uuid: String!) {
    getBillByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        amountDue
        billDate
        billNumber
        billOpt
        billStatus
        billType
        billableId
        billableType
        billedBy
        billedEntityId
        billedEntityType
        canCancel
        canRequestControlNumber
        cancelAffected
        cancelReason
        changeBy
        changeReason
        cnDelivered
        collectionCenter
        controlNumber
        controlNumberExpiredDate
        createdAt
        currency
        description
        exchangeRate
        gfsCode
        id
        invoiceDate
        invoiceNumber
        invoicedBy
        modeOfSettlement
        paidAmount
        remarks
        sourceRef
        spCode
        subSpCode
        taxAmount
        totalAmount
        totalAmountAfterTax
        totalEqvAmount
        uuid
        receipts {
          SPCode
          SPName
          amount
          billAmount
          billNo
          controlAccountNumber
          controlNumber
          currency
          id
          payerCellNumber
          payerEmail
          payerName
          paymentAffected
          paymentDate
          paymentOptions
          paymentReferenceId
          pspCode
          receiptNo
          reconciled
          transactionId
          trdPtyTrxId
          usdPayChn
          uuid
        }
      }
    }
  }
`;
